<template>
  <div class="container">
    <div class="title">
      Spotting at Lajes Air Force Base
    </div>

    <div class="header"></div>
  </div>
</template>

<script>
export default {
  name: "Header"
};
</script>

<style>
.header {
  text-align: center;
  width: 100%;
  height: 250px;
  background-image: url("../assets/header.jpg");
  background-position: center;
  background-repeat: no-repeat;
}

.title {
  background-color: #6495ed;
  display: block;
  font-size: 2em;
  font-weight: bold;
  border-style: solid;
}
</style>
